module.exports = __webpack_public_path__ + "static/media/usuario_com_dados_protegidos.082733b3.svg";